import React, {createRef} from 'react';
import {map as LeafletMap} from 'leaflet';
import autobind from "autobind-decorator";

export class SbWebMap extends React.Component {
    constructor(props) {
        super(props);

        this.mapRef = createRef();

        this.state = {
            map: null
        };
    }

    @autobind
    componentDidMount() {
        //let webmapId = ;//'13750b8b548d48bfa99a9731f2a93ba0'; // Default WebMap ID

        let map = LeafletMap(this.mapRef.current);
        // WebMap(this.props.WebMapId, { map: map });

        this.setState({map});
    }

    @autobind
    render() {
        let style = {};
        if(this.props.style) {
            style = this.props.style;
        }
        let className = "sb-map sb-webmap";
        if(this.props.className) {
            className = className + " " + this.props.className;
        }

        return <div className={className} style={style}>
            <div ref={this.mapRef} />
        </div>;
    }
}


